export default __webpack_public_path__ + "5278df33f538bbd50783473847521409.png";